import dynamic from 'next/dynamic';
export const IconWifi = dynamic(() => import('./IconWifi'));
export const IconAirCondition = dynamic(() => import('./IconAirCondition'));
export const IconDrill = dynamic(() => import('./IconDrill'));
export const IconElectric = dynamic(() => import('./IconElectric'));
export const IconFan = dynamic(() => import('./IconFan'));
export const IconFridge = dynamic(() => import('./IconFridge'));
export const IconLaptop = dynamic(() => import('./IconLaptop'));
export const IconLight = dynamic(() => import('./IconLight'));
export const IconOven = dynamic(() => import('./IconOven'));
export const IconPhone = dynamic(() => import('./IconPhone'));
export const IconTv = dynamic(() => import('./IconTv'));
